import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['submit']

  disable () {
    this.submitTarget.disabled = true
    this.submitTarget.value = this.submitTarget.dataset.loadingLabel
  }
}
